import CountUp from "react-countup";

const VisitantesUnicos = ({ visitas }) => {
  return (
    <div className="bg-white rounded-2xl shadow p-4 text-center">
      <p className="text-sm text-gray-500">Visitantes únicos</p>
      <p className="text-2xl font-bold text-green-600">
        <CountUp end={visitas} duration={1.5} />
      </p>
    </div>
  );
};

export default VisitantesUnicos;
